



























import { computed, defineComponent } from '@vue/composition-api';
import soilApiService from '@/services/soilApiService';
import { useAllResources } from '@/store/modules/resources';
import StratificationDetails from './StratificationDetails.vue';

export default defineComponent({
	components: {
		StratificationDetails,
	},
	emits: ['submitted', 'cancel'],
	props: {
		stratificationJob: {
			required: true,
			type: Object as () => any,
		},
	},
	setup(props: any, { root, emit }) {
		const { isLoading } = useAllResources(root.$store);
		const field = computed(() => root.$store.getters['resources/getFieldByAreaId'](props.stratificationJob.areaId));
		const area = computed(() => root.$store.getters['resources/getAreaById'](props.stratificationJob.areaId));
		const stratificationConfig = JSON.stringify(JSON.parse(props.stratificationJob.stratificationConfig), null, 2);
		const locations = props.stratificationJob.jobResult.locations;
		const handleJobClose = (reason: string) => {
			return async () => {
				try {
					await soilApiService.closeStratificationJob(props.stratificationJob.id, reason);
					emit('submitted');
				} catch (error) {
					let errorMessage;
					switch ((error as any)?.response?.status) {
						case 401:
							errorMessage = 'Unauthorized. Ensure you have the correct permissions.';
							break;
						case 409:
							errorMessage = (error as any)?.response?.data?.message;
							break;
						case 500:
						default:
							errorMessage = 'An error occurred while attempting to close the job. Please try again.';
					}
					alert(errorMessage);
				}
			};
		};

		const stratification = props.stratificationJob.jobResult;

		return {
			isLoading,
			locations,
			area,
			field,
			handleJobClose,
			stratificationConfig,
			stratification: props.stratificationJob.jobResult,
		};
	},
});
